import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useAors } from 'hooks/useAors';
import { useAorText } from 'utils/aorTerminology';

const NONE = '__none__';

/** Tags an Org Files folder with one of the organization's AORs. */
export const AorFolderTagField: React.FC<{
  value: string | null;
  onChange: (aorId: string | null) => void;
}> = ({ value, onChange }) => {
  const aorText = useAorText();
  const { data: aors = [] } = useAors();
  const sorted = [...aors].sort((a, b) =>
    String(a.name ?? '').localeCompare(String(b.name ?? ''))
  );
  const items = [
    { value: NONE, label: 'None' },
    ...sorted.map((aor) => ({ value: aor.id, label: aor.name })),
  ];

  return (
    <div className="dark mb-3">
      <label className="form-label">{aorText('AOR (optional)')}</label>
      <p className="text-muted small mb-2">
        {aorText(
          'Marks this folder as belonging to an area of responsibility.'
        )}
      </p>
      <Select
        value={value ?? NONE}
        items={items}
        onValueChange={(next) =>
          onChange(next == null || next === NONE ? null : String(next))
        }
      >
        <SelectTrigger className="tw:w-full" aria-label={aorText('AOR')}>
          <SelectValue placeholder="None" />
        </SelectTrigger>
        <SelectContent
          className="dark"
          positionerClassName="tw:z-[1100]"
          alignItemWithTrigger={false}
        >
          <SelectItem value={NONE}>None</SelectItem>
          {sorted.map((aor) => (
            <SelectItem key={aor.id} value={aor.id}>
              {aor.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default AorFolderTagField;
